import { Component, OnInit, Output,EventEmitter, Input } from '@angular/core';


@Component({
  selector: 'app-drag-drop-file',
  templateUrl: './drag-drop-file.component.html',
  styleUrls: ['./drag-drop-file.component.scss']
})
export class DragDropFileComponent implements OnInit {
  @Output() fileDropped = new EventEmitter([] as any);
  @Input() disabled = false;
  constructor() { }

  ngOnInit(): void {
  }
  onFileDropped(files:any){
    if(!this.disabled) this.fileDropped.emit(files);
  }
  fileBrowseHandler(files:any){
    console.log('---fileupload from select button---',files);
    if(!this.disabled) this.fileDropped.emit(files);
  }
}
